import styled from 'styled-components';
import classNames from 'classnames';
import { shiftingMethodsList, timePeriodsList } from '../../../../../../../../consts/conditions';
import { Input, Select } from '@mantine/core';
import { IoIosArrowDown } from 'react-icons/io';

export const ShiftingPeriodSection = ({
  columns,
  column,
  shiftingMethod,
  timePeriod,
  periodAmount,
  errors,
  onChangeColumn,
  onChangePeriodAmount,
  onChangeTimePeriod,
  onChangeShiftingMethod
}) => {
  return (
    <ShiftContainer id="grid-table-date-shift-root">
      <div id="grid-table-date-shift-header" className="header">
        <p id="grid-table-date-shift-header-text">Specify shifting date when conditions are met.</p>
      </div>

      <div id="grid-table-date-shift-container" className="container">
        <div id="grid-table-date-shift-box" className="box">
          <div id="grid-table-date-shift-column" className={classNames('form-element')}>
            <Select
              id="grid-table-date-shift-column-select"
              rightSection={<IoIosArrowDown />}
              value={column}
              data={columns}
              onChange={onChangeColumn}
              label="Column"
              placeholder="Select Column"
              required
              error={errors?.includes('columnName')}
              searchable
              clearable
              size="xs"
            />
          </div>

          <div id="grid-table-date-shift-method" className={classNames('form-element')}>
            <Select
              id="grid-table-date-shift-method-select"
              rightSection={<IoIosArrowDown />}
              value={shiftingMethod}
              data={shiftingMethodsList}
              onChange={onChangeShiftingMethod}
              label="Shifting Method"
              required
              placeholder="Select Shifting Method"
              error={errors?.includes('shiftingMethod')}
              searchable
              clearable
              size="xs"
            />
          </div>

          <div id="grid-table-date-shift-period" className={classNames('form-element')}>
            <Select
              id="grid-table-date-shift-period-select"
              rightSection={<IoIosArrowDown />}
              value={timePeriod}
              data={timePeriodsList}
              onChange={onChangeTimePeriod}
              label="Time Period"
              placeholder="Select Time Period"
              required
              error={errors?.includes('timePeriod')}
              searchable
              clearable
              size="xs"
            />
          </div>

          <div id="grid-table-date-shift-amount" className={classNames('form-element')}>
            {errors?.includes('periodAmount') ? (
              <label
                id="grid-table-date-shift-amount-label-error"
                style={{
                  color: 'red'
                }}
              >
                Amount of {timePeriod} - Required
              </label>
            ) : (
              <label id="grid-table-date-shift-amount-label">
                Amount of {timePeriod} <span className="required">*</span>
              </label>
            )}

            <Input
              id="grid-table-date-shift-amount-input"
              value={periodAmount}
              onChange={e => onChangePeriodAmount(e.target.value)}
              required
              type="number"
              placeholder="Type Amount"
              error={errors?.includes('periodAmount')}
              label={`Amount of Time ${timePeriod}`}
              size="xs"
            />
          </div>
        </div>
      </div>
    </ShiftContainer>
  );
};

const ShiftContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 0;
  border-top: 1px solid #cdd4df;

  .required {
    color: red !important;
  }

  .header {
    p {
      color: #2b313d;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 8px;

    .input {
      display: flex;
      flex-direction: column;
      width: 50%;
      gap: 4px;

      input {
        border-radius: 6px;
        background: #f3f3ff;
        height: 24px;
        outline: none;
        border: none;
        padding: 6px;
        color: #5c5d61;

        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      span {
        color: #5c5d61;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .box {
      border: 1px solid #cdd4df;
      border-radius: 4px;
      padding: 8px;
      flex: 1;
      display: flex;
      gap: 8px;
      overflow: auto;

      .form-element {
        min-width: 150px;

        input {
          width: 100%;
        }
      }

      .select {
        text-transform: capitalize;
      }
    }
  }
`;
